/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zahlungsrythmus1Inputs */



/**

* @param {_Field_Zahlungsrythmus1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zahlungsrythmus1 = /** @type {((inputs?: _Field_Zahlungsrythmus1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zahlungsrythmus1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zahlungsrythmus")
});
export { _field_zahlungsrythmus1 as "_field_zahlungsRythmus" }